// extracted by mini-css-extract-plugin
export default {"modeSwitch":"ModeSwitch_modeSwitch__23WeH","button":"ModeSwitch_button__d-EfI"};